export enum SetOfFiltersType {
  READ_ONLY = '0',
  GENERAL = '1',
  USER = '2'
}
